export enum AdminRoleEnum {
  APPLICATION_ADMIN = 'application admin',
  READ_ONLY_ADMIN = 'read only admin'
}
